import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../styled-base/input/text';
import ColorPicker from '../../../styled-base/color-picker';
import { imgUrl } from '../../../utils/url';

export const ColumnHeader = (props: any) => {
    const column = props.column;
    const imgBaseUrl = imgUrl('/images/icons/board/');
    const applyColor = (color: any) => props.applayColColur({color, columnId: column.id, columnColor: column.color, name: `col_name_color_${column.id}`});
    const colorVal = (props.columnColor != undefined ? props.columnColor : (
        typeof column.color === "undefined"
        ? "#184967"
        : column.color ));
    return (
        <div className="wsCustomSettingH">
            <div
                title={column.c_name}
                className={`${column.color} wsAiHeading truncateText left`}
                style={{
                backgroundColor: colorVal
                }}
                id={`col_${column.id}`}
            >
                {column.c_name}
            </div>
            <div className="paintBuketWrap">
                <ColorPicker
                    changeColor={applyColor}
                    color={colorVal}
                >
                    <img
                        className={`paintBuket paintBuket_${column.id}`}
                        src={`${imgBaseUrl}paint_bucket.png`}
                    />
                </ColorPicker>
            </div>
        </div>
    )
}

export const NormalColumnHeader = (props: any) => {
    const { t } = useTranslation();
    const column = props.column;
    return (
        <div
            className={`wsBoard${column.defaultTile}ColTextWrapper`}
            >
            <div className="displayInlineB theamSubHead">
                {t('Change {{defaultTile}} column name to:', { defaultTile: column.defaultTile })}
            </div>
            <div
                className={`displayInlineB vAlignM wsBoard${column.defaultTile}ColTextBoxDiv`}
            >
                <TextField
                    inputProps={{
                        id: `wsBoard${column.defaultTile}Text`,
                        name: `col_name_${column.id}`,
                        value: (props.columnName == undefined ? column.title: props.columnName),
                        style: {
                            width: '200px',
                            border: '1px solid #F0EEEC'
                        }
                    }}
                    classes={`inpTheamColumName wsBoard${column.defaultTile}ColText`}
                    onChangeText={props.onChangeName}
                />
            </div>
            {(column.id == "2" || column.id == "4") && (
                <div className="displayInlineB theamSubHead wsBoardColCheckboxDiv">
                    <input
                        type="checkbox"
                        id={`col_name_hide_${column.id}`}
                        name={`col_name_hide_${column.id}`}
                        checked={props.isChecked}
                        value={column.visible}
                        onChange={e => props.onToggleBox(e)}
                    />
                    <label htmlFor={`wsBoardHide${column.defaultTile}`}>
                        {t('Hide this column')}
                    </label>
                </div>
            )}
            </div>
    )
}